import { Theme, useMediaQuery } from '@mui/material'
import json2mq from 'json2mq'

/**
 * xs: 0,
 * sm: 600,
 * md: 900,
 * lg: 1200,
 * xl: 1536,
 *
 * size: Used by IsSmallerThanSpecified,
 */
export function useScreenSize(size?: number) {
    const isVerySmallScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('xs'),
    )
    const isMobile = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm'),
    )
    const isMediumScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('md'),
    )
    const isBigScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.up('lg'),
    )
    const isMobileTablet = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('lg'),
    )
    const ultrawide = useMediaQuery((theme: Theme) =>
        theme.breakpoints.up('xl'),
    )
    const isLowerLg = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('xl'),
    )
    const isSmallBoxSizeForPaymentTypeBox = useMediaQuery((theme: Theme) =>
        theme.breakpoints.between(900, 1070),
    )
    // Create a media query that matches screens smaller than the specified pixel value (from parameter 'size'.)
    const IsSmallerThanSpecified = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down(size! + 1),
    )

    const isLandscapeMobile = useMediaQuery(
        json2mq({
            maxHeight: 450,
        }),
    )

    const isLandscapeTablet = useMediaQuery(
        json2mq({
            maxHeight: 800,
        }),
    )

    return {
        isVerySmallScreen,
        isMobile,
        isMediumScreen,
        isBigScreen,
        isMobileTablet: isMobileTablet && !isBigScreen,
        isSmallBoxSizeForPaymentTypeBox,
        isLowerLg,
        IsSmallerThanSpecified,
        ultrawide,
        isLandscapeMobile,
        isLandscapeTablet,
    }
}
